export default "__VITE_ASSET__B$_Ac810__"